import { Paragraph, SectionTitle, StyledLink } from 'src/components/Typography';
import { graphql, useStaticQuery } from 'gatsby';

import OnlineOnsiteBlock from './OnlineOnsiteBlock';
import React from 'react';
import { Section } from '../Section';
import { SectionHeaderBlock } from 'src/components/Section/elements';
import { TitleDescription } from '../Typography';
import colors from 'src/style/colors';
/* --- import Media Queries ----*/
import { mediaQueries } from 'src/style/breakpoints';

const OnlineOnsite = React.memo(({ theme }) => {
  const data = useStaticQuery(graphql`
    query {
      rncp5: file(relativePath: { eq: "2023_students4.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 70, width: 550)
        }
      }
      rncp6FullTime: file(relativePath: { eq: "2023_students2.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 70)
        }
      }
      rncp6Alternance: file(relativePath: { eq: "2023_studentsAndTeacher4.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 70)
        }
      }
    }
  `);

  // MODIFIER CES FICHIERS EN MÊME TEMPS : gatsby-node.js et TopBarData.js

  const program = {
    'rncp5-e-learning': {
      title: 'E-learning + mentoring',
      duration: '3 à 6 mois, à votre rythme',
      tags: ['web+web mobile', 'diplômant bac+2', 'e-learning'],
      image: data.rncp5.childImageSharp.gatsbyImageData,
      imageDescription: 'Le Reacteur : Formation Développeur Web',
      content: (
        <Paragraph>
          Vous voulez mettre un pied dans la programmation Web, en avançant à votre rythme ?
          Embarquez sur un parcours en e-learning en étant accompagné, chaque semaine, par un
          formateur (en visio), auquel vous pourrez poser toutes vos questions. Passez un Titre de{' '}
          <StyledLink to="/titre-rncp-developpeur-web-et-web-mobile">
            Développeur Web et Web Mobile
          </StyledLink>{' '}
          (Bac+2), à la fin de votre formation. Un véritable tremplin vers notre{' '}
          <StyledLink to="/formation-alternance/concepteur-developpeur-applications-full-stack-javascript/">
            formation en alternance
          </StyledLink>{' '}
          !
        </Paragraph>
      ),
      link: '/cours-informatique/formation-developpeur-web-et-web-mobile/',
      isActive: true,
    },
    'rncp6-fullTime': {
      title: 'Bootcamp Temps Plein',
      duration: '10 semaines pour apprendre beaucoup, rapidement',
      tags: ['web+mobile', 'diplômant bac+3/4', 'online'],
      image: data.rncp6FullTime.childImageSharp.gatsbyImageData,
      imageDescription: `Le Reacteur Paris : Formation Concepteur Développeur d'Applications`,
      content: (
        <Paragraph>
          Plongez dans 10 semaines de formation intensives à temps plein pour devenir{' '}
          <StyledLink to="/titre-rncp-concepteur-developpeur-d-applications">
            Concepteur Développeur d'Applications
          </StyledLink>{' '}
          (Bac+3/4). Formez-vous avec des experts passionnés, à distance depuis chez vous. Option
          stage de 6 mois (rémunéré, facultatif) pour mettre vos compétences en pratique et
          renforcer votre employabilité. Maîtrisez les outils d’aujourd’hui, y compris ceux liés à
          l’intelligence artificielle.
        </Paragraph>
      ),
      link: '/bootcamp-javascript/concepteur-developpeur-applications-temps-plein/',
      isActive: true,
    },
    'rncp6-alternance': {
      title: 'Formation en alternance',
      duration: '18 mois pour allier code, expérience et salaire',
      tags: ['web+mobile', 'diplômant bac+3/4', 'blendedLearning'],
      image: data.rncp6Alternance.childImageSharp.gatsbyImageData,
      imageDescription: `Le Reacteur Paris : Formation Concepteur Développeur d'Applications en alternance`,
      content: (
        <Paragraph>
          Le meilleur des deux mondes : une formation solide et une vraie expérience en entreprise !
          Devenez{' '}
          <StyledLink to="/titre-rncp-concepteur-developpeur-d-applications-full-stack">
            Concepteur Développeur d'Applications Full Stack
          </StyledLink>{' '}
          (Titre RNCP niveau 6, Bac+3/4) en 18 mois, tout en étant <strong>rémunéré</strong>. On
          vous coache pour trouver l'entreprise parfaite. <strong>Prérequis :</strong> Avoir de
          bonnes bases en code (via notre bootcamp, un Bac+2, notre formation en e-learning ou en
          autodidacte) pour mettre toutes les chances de votre côté.
        </Paragraph>
      ),
      link: '/formation-alternance/concepteur-developpeur-applications-full-stack-javascript/',
      isActive: true,
    },
    'rncp5-alternance': {
      title: 'Formation en alternance',
      duration: '18 mois',
      tags: ['Full Stack', 'diplômant bac+2', 'onSiteAndOrOnline'],
      image: data.rncp6Alternance.childImageSharp.gatsbyImageData,
      imageDescription: 'Le Reacteur Paris : Formation Développeur Full Stack en alternance',
      content: (
        <Paragraph>
          Phasellus ut imperdiet sapien. Suspendisse vitae finibus elit, eget ornare odio. Integer
          et rutrum lorem. Morbi pretium a erat ut accumsan. Passez directement votre Titre RNCP de{' '}
          <StyledLink to="/titre-rncp-developpeur-web-full-stack">
            Développeur Full Stack
          </StyledLink>{' '}
          (Bac+2), en fin de cursus. Integer et rutrum lorem. Morbi pretium a erat ut accumsan. Ut
          hendrerit aliquet diam blandit lobortis.
        </Paragraph>
      ),
      link: '/formation-alternance/developpeur-web-full-stack/',
      isActive: false,
    },
    blockchain: {
      title: 'Bootcamp Blockchain',
      duration: '9 semaines',
      tags: ['Web3/Blockchain', 'certifiant', 'online'],
      image: data.rncp5.childImageSharp.fluid,
      imageDescription: 'Le Reacteur Paris : visio-conférence',
      content: (
        <Paragraph>
          Vous êtes déjà développeur et souhaitez rentrer dans le monde du Web3 ? Entamez une
          formation en cours du soir, du lundi au jeudi, 12 heures par semaine (3 heures chaque
          soir). Vous apprendrez à développer des applications basées sur la Blockchain Ethereum
          grâce à Solidity.
        </Paragraph>
      ),
      link: '/bootcamp-blockchain/formation-developpeur-web3-blockchain-solidity',
      isActive: false,
    },
  };

  return (
    <div>
      <Section
        theme={theme ? theme : 'light'}
        css={{
          [mediaQueries.phoneOnly]: {
            paddingBottom: 56,
          },
        }}
      >
        <SectionHeaderBlock css={{ margin: 'auto', marginBottom: 72, paddingBottom: 0 }}>
          <SectionTitle isMobileCenter isCenter>
            Devenez Développeur
            <br />
            <span css={{ color: colors.purple }}>Web et Mobile</span>
          </SectionTitle>
          <TitleDescription css={{ margin: '15px 0 20px', fontWeight: 'lighter' }}>
            Des formats qui s’adaptent à vous,{' '}
            <br
              css={{
                [mediaQueries.desktopUp]: {
                  display: 'none',
                },
              }}
            />
            et pas l’inverse.
          </TitleDescription>
        </SectionHeaderBlock>

        {Object.keys(program)
          .filter((el) => program[el].isActive)
          .map((elem, index) => {
            return program[elem].isActive ? (
              <OnlineOnsiteBlock
                key={program[elem].title}
                {...program[elem]}
                even={index % 2 === 0}
                isLast={Object.keys(program).length === index + 1}
              />
            ) : null;
          })}
      </Section>
    </div>
  );
});
export default OnlineOnsite;
